import { Environment } from './environment';

/**
 * Attempts to determine the environment of the webapp using the environment
 * variables.
 * 
 * NOT CURRENTLY USED.
 *
 * @returns { string }
 */
export function getEnvFromEnvVariables() {
    switch ( process.env.NODE_ENV ) {
        case 'production':
            return Environment.PROD;
        case 'development':
            return Environment.DEV;
        default:
            return Environment.UNKNOWN;
    }
}

const EXPECTED_DOMAIN_REGEX = /^([a-z]*\.)?((qa|pprd|prod)\.)?([a-z]*\.)biw\.cloud/;

/**
 * Attempts to determine the environment a webapp is being run in by looking
 * at its domain name.
 * 
 * @param { string } domainName - The domain name to check.
 * @returns { string }
 */
export function getEnvFromDomainName( domainName ) {
    // Validate the argument.
    if ( !domainName || typeof domainName !== 'string' || domainName.length <= 1 ) {
        console.warn( `Invalid domain name '${ domainName }'` );
        return Environment.UNKNOWN;
    }

    const matchesPattern = EXPECTED_DOMAIN_REGEX.test( domainName );
    if ( matchesPattern ) {
        // Grab the domain tokens that *might* contain an environment identifier.
        const domainTokens = domainName.toLowerCase().split( '.' );
        const potentialEnvTokens = [
            ( domainTokens.length > 0 ) ? domainTokens[ 0 ] : undefined,
            ( domainTokens.length > 1 ) ? domainTokens[ 1 ] : undefined,
        ].filter( token => token );
    
        for ( let i = 0; i < potentialEnvTokens.length; i++ ) {
            const token = potentialEnvTokens[ i ];
            switch ( token ) {
                case Environment.DEV: {
                    return Environment.DEV;
                }
                case Environment.QA: {
                    return Environment.QA;
                }
                case Environment.PPRD: {
                    return Environment.PPRD;
                }
                case Environment.PROD: {
                    return Environment.PROD;
                }
            }
        }

        // If the environment hasn't yet been figured out and the provided name did match
        // the expected pattern, then we can assume the domain belongs to a PROD environment
        // that might not have the environment embedded in the domain.
        // 
        // Falling back to the PROD environment like this feels sketchy, but as I mentioned
        // above, I think PROD would be the only option in this case...
        return Environment.PROD;
    }
    else {
        // If the provided domain name doesn't match the expected domain pattern, check
        // for exceptions that may defined for your domain.

        // Check to see if the site is being run locally.
        if ( domainName.includes( 'localhost' ) ) {
            // Assumed to be the QA environment for now (can be changed).
            return Environment.QA;
        }

        // ...
    }

    console.warn( `Unexpected domain name '${ domainName }'` );
    return Environment.UNKNOWN;
}
